module.exports = __webpack_public_path__ + "assets/img/config-table-2304e471.png";